import { ConversationList }     from '../../types';
import updateLastReadMessage    from '../../services/UnreadCountService';
import ActionTypes              from '../../ActionTypes';
import conversationListService  from '../../services/ConversationListService';
import { PlaceholderState } from '../../reduxTypes';

const loadConversationsListRequest = () => ({
    type: ActionTypes.CONVERSATIONSLIST_LOAD_MESSAGE
});

const loadConversationsListSuccess = (conversationsList: ConversationList) => ({
    type: ActionTypes.CONVERSATIONSLIST_LOAD_SUCCESS,
    conversationsList
});

const loadConversationsListError = (error: TypeError) => ({
    type: ActionTypes.CONVERSATIONSLIST_LOAD_ERROR,
    error
});

export const setActiveConversation = (activeConversationId: string) => ({
    type: ActionTypes.CONVERSATIONSLIST_SET_ACTIVE,
    activeConversationId
});

export const resetConversationListUnread = (conversationId: string) => ({
    type: ActionTypes.CONVERSATIONSLIST_RESET_UNREAD,
    conversationId
});

export const mapCounter = (conversationId: string) => ({
    type: ActionTypes.CONVERSATIONSLIST_MAP_COUNTER,
    conversationId
});

export const getPlaceholder = (placeholder: PlaceholderState) => ({
    type: ActionTypes.CONVERSATIONSLIST_GET_PLCHLDR,
    placeholder
});

export const deactivatePlaceholder = () => ({
    type: ActionTypes.CONVERSATIONSLIST_OFF_PLCHLDR,
});

export function loadConversationsList(filter?: string, update?: boolean) {
    return async function(dispatch) {
        if (!update) {
            dispatch(loadConversationsListRequest());
        }

        try {
            const conversationList = await conversationListService(filter);

            // Filter out conversations that contain no 'last_message' data
            const legitConversations = conversationList.filter(conversation => conversation.last_message);
            dispatch(loadConversationsListSuccess(legitConversations));
        } catch (error) {
            dispatch(loadConversationsListError(error));
        }
    };
}

export function updateConversationsList(filter?: string) {
    return loadConversationsList(filter, true);
}

export function updateUnreadCount(conversationId: string, messageId: string) {
    return async function unreadUpdater(dispatch) {
        await updateLastReadMessage(conversationId, messageId);

        dispatch(resetConversationListUnread(conversationId));
        dispatch(mapCounter(conversationId));
    };
}



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationsListActions.ts